import Vue from 'vue'
import Vuex from 'vuex'
import apply from './modules/apply'
import app from './modules/app'
import user from './modules/user'
import company from './modules/company'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    apply,
    app,
    user,
    company
  }
});


// WEBPACK FOOTER //
// ./src/store/index.js